var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "top" }, [
      _c("img", {
        attrs: { id: "logo", src: _vm.staticUrl + "logo/T9LOGO.png" },
        on: { click: _vm.initDoc }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "playerBox" },
        [
          _c(
            "el-radio",
            {
              attrs: { label: "0" },
              model: {
                value: _vm.playGameForm.walletType,
                callback: function($$v) {
                  _vm.$set(_vm.playGameForm, "walletType", $$v)
                },
                expression: "playGameForm.walletType"
              }
            },
            [_vm._v("一般钱包")]
          ),
          _vm._v(" "),
          _c(
            "el-radio",
            {
              attrs: { label: "2" },
              model: {
                value: _vm.playGameForm.walletType,
                callback: function($$v) {
                  _vm.$set(_vm.playGameForm, "walletType", $$v)
                },
                expression: "playGameForm.walletType"
              }
            },
            [_vm._v("免转钱包2")]
          ),
          _vm._v(" "),
          _vm.isDevEnv
            ? _c(
                "el-radio",
                {
                  attrs: { label: "3" },
                  model: {
                    value: _vm.playGameForm.walletType,
                    callback: function($$v) {
                      _vm.$set(_vm.playGameForm, "walletType", $$v)
                    },
                    expression: "playGameForm.walletType"
                  }
                },
                [_vm._v("JDB錢包")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "currencyBox" }, [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.currentCurrency,
                    expression: "currentCurrency"
                  }
                ],
                staticClass: "selectClass",
                on: {
                  change: [
                    function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.currentCurrency = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                    _vm.onCurrencyChange
                  ]
                }
              },
              _vm._l(_vm.currencys, function(item) {
                return _c(
                  "option",
                  {
                    key: item.index,
                    staticClass: "optionClass",
                    domProps: { value: item }
                  },
                  [_vm._v("\n            " + _vm._s(item) + "\n          ")]
                )
              }),
              0
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "langBox", on: { click: _vm.requestShow } },
            [
              _c("img", { attrs: { src: _vm.getlang, alt: "", id: "mylang" } }),
              _vm._v(" "),
              _c("i", { staticClass: "el-icon-d-caret" }),
              _vm._v(" "),
              _vm.showOpt
                ? _c(
                    "div",
                    { staticClass: "langOptions" },
                    _vm._l(_vm.langsopts, function(item) {
                      return _c(
                        "div",
                        {
                          key: item.id,
                          staticClass: "langItem",
                          on: {
                            click: function($event) {
                              return _vm.setLangs(item)
                            }
                          }
                        },
                        [
                          _c("img", {
                            staticClass: "optlang",
                            attrs: { src: item.imgs, alt: "", id: "mylang" }
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(item.values))])
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.formData.playerID,
                expression: "formData.playerID"
              }
            ],
            staticClass: "idType",
            attrs: { maxlength: "51", placeholder: "playerID" },
            domProps: { value: _vm.formData.playerID },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.formData, "playerID", $event.target.value)
              }
            }
          }),
          _vm._v(" "),
          _vm.isDevEnv
            ? _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.inputAmount,
                    expression: "inputAmount"
                  }
                ],
                staticClass: "idType",
                attrs: { maxlength: "9", placeholder: "0-10000000" },
                domProps: { value: _vm.inputAmount },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.inputAmount = $event.target.value
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              class: { hasTrial: _vm.IsTrial, trialBtn: true },
              on: { click: _vm.requestTrial }
            },
            [_vm._v("\n        Trial\n      ")]
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "content" }, [
      _c("div", { staticClass: "bgBox" }),
      _vm._v(" "),
      _c("div", { staticClass: "gameList" }, [
        _c(
          "div",
          { staticClass: "rowSize" },
          [
            _vm.isDevEnv
              ? _c("div", { staticClass: "gameBoxLi" }, [
                  _c("div", {
                    staticClass: "gameBox",
                    staticStyle: {
                      "background-image": "url('../../static/format_list.png')",
                      "background-color": "black"
                    },
                    on: { click: _vm.goToMock }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "gameNameBox" }, [
                    _vm._v("工具&模擬器")
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.showLobby && _vm.isDevEnv
              ? _c("div", { staticClass: "gameBoxLi" }, [
                  _c("div", {
                    staticClass: "gameBox eventbox2",
                    staticStyle: {
                      "background-image": "url('../../static/logo_go9.png')"
                    },
                    on: {
                      click: function($event) {
                        return _vm.goGo9()
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "gameNameBox" }, [_vm._v("Go9")])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.showLobby
              ? _c("div", { staticClass: "gameBoxLi" }, [
                  _c("div", {
                    staticClass: "gameBox eventbox2",
                    on: {
                      click: function($event) {
                        return _vm.eventLobby()
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "gameNameBox" }, [
                    _vm._v("來唄!輪盤轉不停")
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.showLobby
              ? _c("div", { staticClass: "gameBoxLi" }, [
                  _c("div", {
                    staticClass: "gameBox eventbox2",
                    staticStyle: {
                      "background-image": "url('../../static/laibe.png')"
                    },
                    on: {
                      click: function($event) {
                        return _vm.playGame({
                          gameCode: "1999",
                          gameName: "hot game"
                        })
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "gameNameBox" }, [
                    _vm._v("Hot Game")
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.showLobby && _vm.isDevEnv
              ? _c("div", { staticClass: "gameBoxLi" }, [
                  _c("div", {
                    staticClass: "gameBox eventbox2",
                    staticStyle: {
                      "background-image":
                        "url('../../static/gameicon_happy.png')"
                    },
                    on: {
                      click: function($event) {
                        return _vm.playHotTV()
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "gameNameBox" }, [_vm._v("HOT TV")])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.isDevEnv
              ? _c("div", { staticClass: "gameBoxLi" }, [
                  _c("div", {
                    staticClass: "gameBox",
                    staticStyle: {
                      "background-image":
                        "url('../../static/gameicon_4013.png')"
                    },
                    on: {
                      click: function($event) {
                        return _vm.playGame({
                          gameCode: 4013,
                          gameName: "黄金水果嘉年华TV",
                          gameType: 4
                        })
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "gameNameBox" }, [
                    _vm._v("黄金水果嘉年华TV")
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.isDevEnv
              ? _c("div", { staticClass: "gameBoxLi" }, [
                  _c("div", {
                    staticClass: "gameBox",
                    staticStyle: {
                      "background-image":
                        "url('../../static/gameicon_4010_1.png')"
                    },
                    on: {
                      click: function($event) {
                        return _vm.playGame({
                          gameCode: 4014,
                          gameName: "猜拳奪寶TV",
                          gameType: 4
                        })
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "gameNameBox" }, [
                    _vm._v("猜拳奪寶TV")
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.myGames, function(g, index) {
              return _c("div", { key: index, staticClass: "gameBoxLi" }, [
                _vm.iconLan == "zh-CN"
                  ? _c("div", {
                      staticClass: "gameBox",
                      style: {
                        "background-image":
                          "url(" +
                          _vm.staticUrl +
                          "icon/" +
                          g.gameCode +
                          ".png)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.playGame(g)
                        }
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.iconLan != "zh-CN"
                  ? _c("div", {
                      staticClass: "gameBox",
                      style: {
                        "background-image":
                          "url(" +
                          _vm.staticUrl +
                          "icon/" +
                          _vm.iconLan +
                          "/" +
                          g.gameCode +
                          ".png)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.playGame(g)
                        }
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("span", { staticClass: "gameNameBox" }, [
                  _vm._v(_vm._s(g.gameName))
                ])
              ])
            }),
            _vm._v(" "),
            _vm.showLobby
              ? _c("div", { staticClass: "gameBoxLi" }, [
                  _c("div", {
                    staticClass: "gameBox eventbox",
                    on: {
                      click: function($event) {
                        return _vm.playLobby()
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "gameNameBox" }, [
                    _vm._v("play lobby")
                  ])
                ])
              : _vm._e()
          ],
          2
        )
      ])
    ]),
    _vm._v(" "),
    _vm._m(0)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bottom" }, [
      _c("span", { staticClass: "versionTxt" }, [_vm._v("Version ⚅ 1.2.1")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-469af010", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-469af010","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HelloWorld.vue
// module id = null
// module chunks = 